import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as HighCharts from 'highcharts';
import template from './dashboard.tpl.html';
import { States } from "../../shared/config/constant.module";
import { apsEnums } from "../../shared/dto/aps.enums";
import { LineCounts } from "../../models/counts/lineCounts";
import { apsDisplayEnums } from "../../shared/dto/enums";
import { StateParams } from "../../common";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsEvents } from "../../shared/dto/aps.events";
import { apsCommon } from "../../shared/dto/aps.common";
import DateUtilityService from "../../services/utility/dateutility.service";
import UIUtilityServiceName, { UIUtilityService } from "../../services/utility/uiUtility.service";
import CountsServiceName, { CountsService } from "../../services/counts/counts.service";
import ShopServiceName, { ShopService } from "../../services/shops/shops.service";
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import GroupRejectsServiceName, { GroupRejectsService } from "../../services/counts/groupRejects.service";
import TopDefectsHubName, { TopDefectsHub, TopDefectsHubCreator } from "../../services/reports/topDefects.hub";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import { TopDefectsReportParams } from "../reports/topDefectsReport.controller";
import { IBtn, IBtnArrayOptions } from './btnarray.interfaces';

let requires = [UIUtilityServiceName, CountsServiceName, 
  ShopServiceName, ReportServiceName, LoaderServiceName,
  GroupRejectsServiceName, TopDefectsHubName, 
  NavigationServiceName];

// interface ShiftSelector {
//   name: string;
//   start: Date;
//   end: Date;
//   selected: boolean;
// }

enum DashboardTab {
  Weights = 1,
  TopDefects = 2,
  TopRejects = 3
}

export class DashboardController {
  $name: string;
  plantId: string;
  shopId: string;
  shopName: string;
  shiftSelectors: IBtnArrayOptions;
  plantName: string;
  $state: angular.ui.IStateService;
  packEfficiency: apsEnums.WellKnownCheckType;
  heEfficiency: apsEnums.WellKnownCheckType;
  defectQueryStart: Date;
  defectQueryEnd: Date;
  reportService: ReportService;
  loaderService: LoaderService;
  groupRejectsService: GroupRejectsService;
  chartClickWorkaround: any;
  viewGroupRejects: (dimpleEvent: any) => void;
  hasScale: boolean;
  weightHtml: string;
  weightHourOptions: number[];
  countsService: CountsService;
  model: LineCounts;
  countsInterval: apsDisplayEnums.CountDisplayInterval;
  selectedTab: DashboardTab = DashboardTab.TopDefects;
  hasLines: boolean;
  showMaintenance: boolean;
  showMaintCheckbox: boolean;
  $interval: angular.IIntervalService;
  defects: apsViewModels.TopNDefectReportItem[];
  defectsPretty: any[];
  defectNameToColor: any;
  uiUtilityService: UIUtilityService;
  $q: angular.IQService;
  dashboardTab: typeof DashboardTab = DashboardTab;
  topTenDefects: any;

  private hub: TopDefectsHub;
  private $scope: angular.IScope;
  private $timeout: angular.ITimeoutService;
  private $stateParams: StateParams;
  private shopService: ShopService;
  private $sce: angular.ISCEService;

  constructor(
    $stateParams: StateParams,
    shopService: ShopService,
    loaderService: LoaderService,
    groupRejectsService: GroupRejectsService,
    reportService: ReportService,
    topDefectsHubCreator: TopDefectsHubCreator,
    $scope: angular.IScope,
    $sce: angular.ISCEService,
    uiUtilityService: UIUtilityService,
    $timeout: angular.ITimeoutService,
    $state: angular.ui.IStateService,
    countsService: CountsService,
    navigationService: NavigationService,
    $q: angular.IQService,
    $interval: angular.IIntervalService) {

    var $ctrl = this;
    this.$name = "dashboard.controller";
    this.plantId = $stateParams.plantId;
    this.shopId = $stateParams.shopId;
    this.reportService = reportService;
    this.loaderService = loaderService;
    this.groupRejectsService = groupRejectsService;
    this.shopService = shopService;
    this.$sce = $sce;
    this.shopName = null;
    this.plantName = null;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.uiUtilityService = uiUtilityService;
    this.packEfficiency = apsEnums.WellKnownCheckType.ShopPackEfficiency;
    this.heEfficiency = apsEnums.WellKnownCheckType.HotEndEfficiency;
    this.weightHtml = null;
    this.weightHourOptions = [4, 24];
    this.countsService = countsService;
    this.model = null;
    this.countsInterval = apsDisplayEnums.CountDisplayInterval.Last24Hours;
    this.$q = $q;
    this.hasLines = false;
    this.showMaintenance = false;
    this.showMaintCheckbox = true;
    this.$interval = $interval;
    this.shiftSelectors = {
      buttons: [],
      select: null
    } as IBtnArrayOptions;

    this.topTenDefects = {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      yAxis: {
        title: { enabled: false }
      },
      xAxis: {
        categories: []
      },
      legend: { enabled: false },
      credits: {
        enabled: false
      },
      exporting: { enabled: false },
      tooltip: {
        formatter: function () {
          return 'Defect: <b>' + this.x + '</b><br />'
            + this.series.name + ': <b>' + this.y + '</b>';
        }
      },
      series: [],
      reflow: true,
      callBack: null // angular.bind(this, this.chartClickWorkaround.defectBarClick)
    };

    let shopPromise = shopService.getShopConfiguration(this.shopId).then(shop => {
      this.shopName = shop.name;
      this.plantName = shop.plantName;
      this.hasScale = shop.hasScale;
      this.hasLines = shop.hasLines;

      if (shop.hasLines) {
        let countsPromise = navigationService.getNavigation().then(nav => {
          countsService.getLineCounts(this.shopId, nav.selectedPlant, this.countsInterval, false)
            .then(countsResult => {
              this.model = countsResult;
            });
        });
        loaderService.loadingPromise(countsPromise);
      }

      let now = moment();
      let twentyFourHoursAgo = now.clone().subtract(24, 'hours');

      this.defectQueryEnd = DateUtilityService.localToTimeZone(now.toDate(), shop.timeZoneId).toDate();
      this.defectQueryStart = DateUtilityService.localToTimeZone(twentyFourHoursAgo.toDate(), shop.timeZoneId).toDate();

      this.populateShiftSelectors(
        this.defectQueryStart,
        this.defectQueryEnd,
        shop.shiftsInLast24Hours);

      if (!this.hasScale) {
        this.loadDefectsReport(this.defectQueryStart);
      }
    });

    this.hub = topDefectsHubCreator.createTopDefectsHub(
      this.shopId,
      d => this.onDefectAdded(d),
      d => this.onDefectRemoved(d)
    );

    this.$scope.$on('$destroy', () => {
      if (this.hub) {
        this.hub.uninitialize();
      }
    });

    this.viewGroupRejects = (dimpleEvent: any): void => {
      if (dimpleEvent && dimpleEvent.category) {
        let equipmentGroup = _.find(this.model.equipmentGroups, { name: dimpleEvent.category });
        this.model.currentGroup = equipmentGroup;
        this.groupRejectsService.showGroupRejects({
          equipmentGroup: equipmentGroup,
          shopId: this.shopId,
          lineCounts: this.model,
          countsInterval: this.countsInterval
        });
      }
    };

    this.chartClickWorkaround = {
      defectBarClick: (evt) => {
        if (evt && evt.y && evt.category) {
          let selectedDefect = _.find(this.defects, {
            defectTypeName: evt.category,
            count: evt.y
          });
          if (selectedDefect) {
            this.defectBarClick(selectedDefect);
          }
        }
      }
    };

    this.topTenDefects.callBack = angular.bind(this, this.chartClickWorkaround.defectBarClick);

    loaderService.loadingPromise(shopPromise);
  }

  setSelectedTab(tab: DashboardTab): void {
    if (this.hasScale) {
      if (tab === 2) {
        this.loadDefectsReport(this.defectQueryStart);
      }
    }
    this.$timeout(() => this.selectedTab = tab, 50);
  }

  updateTopTenDefectsBot(): void {
    var vm = this;
    this.topTenDefects.xAxis.categories = this.defectsPretty.map(function (item) { return item.Defect; });
    this.topTenDefects.series = [{
      name: 'Count',
      data: this.defectsPretty.map(
        function (item) {
          return {
            y: item.Count,
            color: vm.defectNameToColor[item.Defect],
            defects: vm.defects,
            events: {
              click: function (event: any) {
                let selectedDefect = _.find(this.options.defects, {
                  defectTypeName: this.category,
                  count: this.y
                });
                if (selectedDefect) {
                  vm.defectBarClick(selectedDefect as apsViewModels.TopNDefectReportItem);
                }
              }
            }
          };
        })
    }];
  }

  private updateDefects(): void {
    this.defectNameToColor = {};
    _.forEach(this.defects, (d) => {
      let color = this.uiUtilityService.getSeverityColor(d.severity);
      if (color) {
        this.defectNameToColor[d.defectTypeName] = color;
      }
    });

    let unSortedDefectsPretty = _.map(this.defects, (d) => {
      return {
        'Defect': (<any>d).defectTypeName,
        'Count': (<any>d).count,
        'Sort Value': ((<any>d).count * 100) + (10 - (<any>d).severity)
      };
    });
    this.defectsPretty = _.orderBy(unSortedDefectsPretty, ['Count', 'Severity'], ['desc', 'asc']);

    this.$timeout(() => {
      this.updateTopTenDefectsBot();
      // this.updateTopTenRejectsBot();
    }, 50);
  }

  private onDefectAdded(defect: apsViewModels.TopDefectEvent) {
    if (!this.defects || this.defectQueryStart.getTime() > defect.timeFound.getTime()) {
      return;
    }

    this.$timeout(() => {
      let existing = _.find(this.defects, { defectTypeId: defect.defectTypeId });
      if (existing) {
        existing.count = existing.count + 1;
        if (existing.severity > defect.severity) {
          existing.severity = defect.severity;
        }
      } else {
        this.defects.push(<apsViewModels.TopNDefectReportItem>_.assign({ count: 1 }, defect));
      }
      this.updateDefects();
    });
  }

  private onDefectRemoved(defect: apsViewModels.TopDefectEvent) {
    if (!this.defects || this.defectQueryStart.getTime() > defect.timeFound.getTime()) {
      return;
    }

    let existing = _.find(this.defects, { defectTypeId: defect.defectTypeId });
    if (!existing) {
      return;
    }

    this.$timeout(() => {
      existing.count = existing.count - 1;
      if (existing.count <= 0) {
        _.remove(this.defects, existing);
      }
      this.updateDefects();
    });
  }

  loadDefectsReport(queryStart: Date, queryEnd?: Date): angular.IPromise<any> {
    this.defectQueryStart = queryStart;
    this.defectQueryEnd = queryEnd;
    return this.reportService.getTopDefectsReport(this.shopId, queryStart, queryEnd, undefined, undefined, this.showMaintenance)
      .then(defects => {
        this.defects = defects;
        this.updateDefects();
      });
  }

  populateShiftSelectors(allStart: Date, allEnd: Date, shopShifts: apsCommon.PlantShiftInstance[]) {
    let allShifts = [];
    allShifts.push({
      name: 'All',
      value: {
        start: allStart,
        end: null,
      },
      selected: true,
    } as IBtn);

    _.forEach(shopShifts, (s, i) => {
      let shiftName = (i === 0) ? 'Current' : 'Shift -' + i;
      // only show full shifts
      if (allStart < s.startTime) {
        allShifts.push({
          name: shiftName,
          value: {
            start: s.startTime,
            end: s.stopTime,
          },
          selected: false
        } as IBtn);
      }
    });

    this.shiftSelectors = {
      buttons: allShifts,
      select: (button: IBtn) => {
        this.selectShift(button);
      }
    };
  }

  selectShift(shift: IBtn): void {
    this.loaderService.loadingPromise(
      this.loadDefectsReport(
        shift.value.start,
        shift.value.end));
  }

  IncludeMaintenence(): void {
    this.loaderService.loadingPromise(this.loadDefectsReport(this.defectQueryStart, this.defectQueryEnd));
  }

  defectBarClick(defect: apsViewModels.TopNDefectReportItem): void {
    let reportStateParams: TopDefectsReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: undefined,
      reportShopId: undefined,
      startDate: this.defectQueryStart.toISOString(),
      endDate: this.defectQueryEnd ? this.defectQueryEnd.toISOString() : undefined,
      defectTypeId: defect.defectTypeId,
      filter: apsEnums.TopDefectsFilter.Top10Defects,
      autoRun: true
    };
    this.$state.go(States.TOP_DEFECTS_REPORT, reportStateParams);
  }
}

export default angular.module('aps.controller.dashboard', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.DASHBOARD,
      url: '/dashboard',
      controller: 'DashboardCtrl as vm',
      template: template,
      data: { pageTitle: 'Shop Dashboard' }
    });
  })
  .controller('DashboardCtrl', DashboardController)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/dashboard.controller.ts